import { useEffect, useState } from 'react';

export const useShowcaseSignature = (albumId: string | number | undefined) => {
  const [signature, setSignature] = useState<string | null>(null);

  useEffect(() => {
    if (!albumId || signature !== null) return;

    const showcasePageSignature = getSSGMetaDataFromDOM(`album-signature-${albumId}`);

    if (showcasePageSignature) {
      setSignature(showcasePageSignature);
    } else {
      setSignature('');
    }
  }, [albumId, signature]);

  return signature;
};

const getSSGMetaDataFromDOM = (key: string) =>
  document.querySelector(`meta[name=${key}]`)?.getAttribute('content');
